import React from 'react';
import { BaseInstructionScreen, List, InstructionSection } from './BaseInstructionScreen';

const ReadingInstructions = ({ onBack, onStart }) => {
  return (
    <BaseInstructionScreen
      title="TOEFL Reading Test"
      icon="📚"
      gradientStart="#e74c3c"
      gradientEnd="#c0392b"
      bulletColor="#e74c3c"
      onBack={onBack}
      onStart={onStart}
    >
      <InstructionSection>
        <h2>Test Format</h2>
        <List bulletColor="#e74c3c">
          <li>3-4 academic passages, 700 words each</li>
          <li>10 questions per passage</li>
          <li>30-40 questions in total</li>
          <li>54-72 minutes total time</li>
        </List>
      </InstructionSection>

      <InstructionSection>
        <h2>Question Types</h2>
        <List bulletColor="#e74c3c">
          <li>Main idea and detail questions</li>
          <li>Inference questions</li>
          <li>Vocabulary questions</li>
          <li>Reference questions</li>
          <li>Insert text and summary questions</li>
        </List>
      </InstructionSection>

      <InstructionSection>
        <h2>Tips for Success</h2>
        <List bulletColor="#e74c3c">
          <li>Skim the passage first for main ideas</li>
          <li>Use time management - about 20 minutes per passage</li>
          <li>Pay attention to transition words and topic sentences</li>
          <li>Use process of elimination for difficult questions</li>
        </List>
      </InstructionSection>
    </BaseInstructionScreen>
  );
};

export default ReadingInstructions; 